module.exports = __webpack_public_path__ + "img/index-selected-icon.9ea3041a.svg";